import React from "react";

import {GraphQlSelect} from "./GraphQlSelect";
import {useSubletterQueryQuery} from "../../generated/graphql";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const SubletterSelect = (props) => {
    const query = useSubletterQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="name" />:<GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}
